//export const colors = { primary: "bg-[#02134d]" };

export const snackBarColors = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};
